module.exports = __webpack_public_path__ + "static/404-f6182030cf10085c47e19c59cf6cbc6e.png";